module.exports = __webpack_public_path__ + "static/media/logo-white.44c0d308.png";